import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { Bot, Check, Copy } from 'lucide-react'

// Shared copy-paste panel for generated Claude Code prompts. Originally
// local to DossierDetail.tsx (SEO/security/GSC/content instructions);
// extracted so other pages (e.g. Inventory.tsx) can reuse the exact same
// look/copy-behaviour instead of re-implementing it.
interface InstructionsPanelProps {
  title: string
  prompt: string
  loading?: boolean
  onClose?: () => void
}

export function InstructionsPanel({ title, prompt, loading, onClose }: InstructionsPanelProps) {
  const [copied, setCopied] = useState(false)
  const handleCopy = async () => {
    await navigator.clipboard.writeText(prompt)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Bot className="h-5 w-5 text-primary" />
            <CardTitle>{title}</CardTitle>
          </div>
          <div className="flex items-center gap-2">
            <Button size="sm" onClick={handleCopy} variant={copied ? 'default' : 'outline'} disabled={loading}>
              {copied ? <><Check className="h-4 w-4 mr-1.5" />Gekopieerd!</> : <><Copy className="h-4 w-4 mr-1.5" />Kopieer</>}
            </Button>
            {onClose && <button onClick={onClose} className="rounded p-1 text-muted-foreground hover:bg-muted">✕</button>}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex items-center gap-3 py-6 justify-center text-muted-foreground text-sm">
            <Spinner size="sm" /> Bevindingen ophalen...
          </div>
        ) : (
          <textarea readOnly value={prompt}
            className="w-full rounded-lg border bg-muted/40 p-4 font-mono text-xs leading-relaxed resize-none focus:outline-none"
            rows={Math.min(32, prompt.split('\n').length + 2)}
            onFocus={e => e.target.select()} />
        )}
      </CardContent>
    </Card>
  )
}
